export default "__VITE_ASSET__67ff9413__$_?nuxt_component=async__"